import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SEARCH_CATEGORY_MAPPING } from '../../components/artifacts/util/artifactsConstants'
import { getArtifactsByKeyword } from '../../services/artifactService'
import useNotifications from '../useNotifications'

/**
 * Hook for fetching search results from all artifacts.
 * Uses same search engine as patron-facing Find page.
 * @param {searchTerms: string, artifactCategory: string, paginatorOffset: number, paginatorCount: number}
 * @returns {Object} object with loading boolean, error status/data, artifacts array, and page count
 */
const useArtifactSearchResults = ({ searchTerms, artifactCategory, paginatorOffset, paginatorCount }) => {
  const { t } = useTranslation()
  const [artifacts, setArtifacts] = useState()
  const [totalArtifactsSpanningPages, setTotalArtifactsSpanningPages] = useState(0)
  const { error } = useNotifications()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { status, data } = await getArtifactsByKeyword(
          searchTerms,
          SEARCH_CATEGORY_MAPPING[artifactCategory.toUpperCase()],
          paginatorCount,
          paginatorOffset
        )
        if (status !== 200) {
          throw data || status
        }
        setTotalArtifactsSpanningPages(data.totalArtifactsSpanningPages)
        setArtifacts(data.artifact)
      } catch (err) {
        error(
          t('hooks.errors.retrievingArtifactsBasedOnSearchTerms', `Error retrieving artifacts based on search terms`),
          err
        )
        setArtifacts([])
      }
    }
    fetchData()
  }, [paginatorOffset, artifactCategory, searchTerms, paginatorCount, error, t])

  return {
    artifacts,
    totalArtifactsSpanningPages,
  }
}

export default useArtifactSearchResults
